import { render, staticRenderFns } from "./workareaNewComp.vue?vue&type=template&id=09b731a8&scoped=true"
import script from "./workareaNewComp.vue?vue&type=script&lang=js"
export * from "./workareaNewComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b731a8",
  null
  
)

export default component.exports